import { useRef } from "react"
import { Box } from "@mui/material"
import Tabs, { tabsClasses } from "@mui/material/Tabs"
import { IconButton, ThemeProvider } from "@mui/material"

import { CustomTab, LeftIcon, RightIcon, theme } from "./Atom"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"

export default function HuddleTabs(props: any) {
  const { fetchByHuddleTabId } = props

  const dispatch = useDispatch()
  const tabsRef = useRef<any>(null)

  const handleChange = async (tab: any) => {
    fetchByHuddleTabId(tab)
  }

  const selectedHuddleTab = useSelector((state: any) => {
    return state.huddle.selectedHuddleTab
  })

  const huddleTabs = useSelector((state: any) => {
    return state.huddle.huddleTabs
  })

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          flexGrow: 0,
          maxWidth: { xs: "100%", sm: "100%", xl: "100%", md: "100%" },
          bgcolor: "#1A428A",
          display: "flex",
          alignItems: "flex-end",
          color: "primary.main",
          height: "8vh",
        }}
      >
        <Tabs
          ref={tabsRef}
          value={selectedHuddleTab?.index || 0}
          onChange={handleChange}
          variant="standard"
          aria-label="huddle tabs"
          sx={{
            color: "primary.main",
            position: "relative",
            height: "8vh",
            paddingRight: 13,
          }}
          TabIndicatorProps={{
            style: { display: "none" },
          }}
        >
          {huddleTabs.map((tab: any, index: any) => (
            <CustomTab
              key={tab?.id}
              label={tab?.name}
              onClick={() => handleChange(tab)}
              style={{
                backgroundColor:
                  selectedHuddleTab?.index === index ? "#ffffff" : "#1c56ce",
                color: selectedHuddleTab?.index === index ? "black" : "white",
                marginLeft: index === 0 ? "8px" : "0",
                fontSize: selectedHuddleTab?.index === index ? "16px" : "16px",
                fontWeight: selectedHuddleTab?.index === index ? "600" : "400",
                width: "fit-content",
                textTransform: "capitalize",
              }}
            />
          ))}
        </Tabs>
      </Box>
    </ThemeProvider>
  )
}
